import React, { Component } from 'react';
import { withRouter } from "react-router";
import { connect } from "react-redux";
import * as actions from "../../actions/ordersAction";
import { bindActionCreators } from 'redux';
import CommonHeaderComponent from "../headers/CommonHeaderComponent";
import * as symbols from "../../operations/symbols";

class CODComponent extends Component {

  handleCashCollectedClick() {
    const orderId = this.props.match.params.id;
    this.props.actions.updateOrder({ orderId: orderId, data: { totalCash: parseInt(this.props.location.state.cash) } });

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { updateOrderStatus } = this.props;
    if (updateOrderStatus !== prevProps.updateOrderStatus && updateOrderStatus === symbols.STATUS_DONE) {
      this.props.history.push({
        pathname: '/order/' + this.props.match.params.id + "/verifyDelivery",
        state: { orderNumber: this.props.location.state.orderNumber }
      })
    }
  }

  render() {
    return (
      <div>
        {
          !this.props.location.state ?
            <div>
              <CommonHeaderComponent title={"COD"} enableBack={true}/>
              <div className="pd-top-global fs-18 red-text center">
                Unauthorized!!!
              </div>
            </div>
            :
            <div>
              <CommonHeaderComponent title={`${this.props.location.state.orderNumber}`} enableBack={true}/>
              <div className="phone-card fs-24 pd-top-global green-text center">
                <div className="mb-2 pd-top-global">Collect Cash</div>
                <div className="fs-28">₹{this.props.location.state.cash}</div>
              </div>
              <div className="order-card mt-2 fixed-verify-section z-highest">
                <div className={"btn btn-expand btn-green "} onClick={() => this.handleCashCollectedClick()}>
                  I have collected the cash
                </div>
              </div>
            </div>
        }
      </div>
    )
  }
}

export default withRouter(connect(
  state => ({
    updateOrderStatus: state.statuses.updateOrder.status,
    updateOrderError: state.statuses.updateOrder.error,
    orders: state.orders,
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(CODComponent));
